/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IntegrationTypeFromJSON, IntegrationTypeToJSON, } from './IntegrationType.js';
/**
 * Check if a given object implements the GetCompanyPlanResult interface.
 */
export function instanceOfGetCompanyPlanResult(value) {
    if (!('hasSubscription' in value) || value['hasSubscription'] === undefined)
        return false;
    if (!('activeJobs' in value) || value['activeJobs'] === undefined)
        return false;
    if (!('scoutCredits' in value) || value['scoutCredits'] === undefined)
        return false;
    if (!('canMatch' in value) || value['canMatch'] === undefined)
        return false;
    if (!('integrationTypes' in value) || value['integrationTypes'] === undefined)
        return false;
    return true;
}
export function GetCompanyPlanResultFromJSON(json) {
    return GetCompanyPlanResultFromJSONTyped(json, false);
}
export function GetCompanyPlanResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hasSubscription': json['hasSubscription'],
        'jobSlots': json['jobSlots'] == null ? undefined : json['jobSlots'],
        'activeJobs': json['activeJobs'],
        'scoutCredits': json['scoutCredits'],
        'matchCredits': json['matchCredits'] == null ? undefined : json['matchCredits'],
        'canMatch': json['canMatch'],
        'mainAtsIntegrationConnectionId': json['mainAtsIntegrationConnectionId'] == null ? undefined : json['mainAtsIntegrationConnectionId'],
        'integrationTypes': (json['integrationTypes'].map(IntegrationTypeFromJSON)),
    };
}
export function GetCompanyPlanResultToJSON(json) {
    return GetCompanyPlanResultToJSONTyped(json, false);
}
export function GetCompanyPlanResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'hasSubscription': value['hasSubscription'],
        'jobSlots': value['jobSlots'],
        'activeJobs': value['activeJobs'],
        'scoutCredits': value['scoutCredits'],
        'matchCredits': value['matchCredits'],
        'canMatch': value['canMatch'],
        'mainAtsIntegrationConnectionId': value['mainAtsIntegrationConnectionId'],
        'integrationTypes': (value['integrationTypes'].map(IntegrationTypeToJSON)),
    };
}
